import { render, staticRenderFns } from "./SocialSignin.vue?vue&type=template&id=2b33be98&scoped=true"
import script from "./SocialSignin.vue?vue&type=script&lang=js"
export * from "./SocialSignin.vue?vue&type=script&lang=js"
import style0 from "./SocialSignin.vue?vue&type=style&index=0&id=2b33be98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33be98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b33be98')) {
      api.createRecord('2b33be98', component.options)
    } else {
      api.reload('2b33be98', component.options)
    }
    module.hot.accept("./SocialSignin.vue?vue&type=template&id=2b33be98&scoped=true", function () {
      api.rerender('2b33be98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/SocialSignin.vue"
export default component.exports